// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PricingInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Pricing publish or override request body — Full-gated.
 *
 * Used for both:
 *   POST ai/credits/pricing          — publish new versioned GLOBAL row
 *   POST ai/credits/pricing/override — publish new versioned per-franchise OVERRIDE
 *
 * Required fields (both actions):
 *   model_name             (string)  — AI model identifier (e.g. 'deepseek-v4-flash')
 *   cache_hit_usd_per_1m   (string)  — decimal(18,8) provider rate
 *   cache_miss_usd_per_1m  (string)  — decimal(18,8) provider rate
 *   output_usd_per_1m      (string)  — decimal(18,8) provider rate
 *   valid_from              (string)  — ISO datetime (YYYY-MM-DD HH:MM:SS)
 *
 * Required only for override action:
 *   franquia_id            (int)     — target franchise
 *
 * All rate values arrive as decimal strings — stored verbatim, no float coercion.
 *
 * --- markup / peg_brl / fx_rate_usd_brl retired (M6b-1) ---
 * As of M3, credits are computed as `provider_cost_usd / ai_credit_peg_usd`
 * (a single GLOBAL setting) — markup, peg_brl and fx_rate_usd_brl never
 * influenced how many credits a prompt burns. M6b-1 removed them from this
 * contract entirely (they are no longer accepted, validated, or echoed back
 * anywhere in PHP): every reader that ever reconstructed COGS/billing from
 * these columns is gone (`estimatePeriodCost()` deleted in M2;
 * `Ai_credit_ledger_model::getPeriodCostRows()` — its only caller — retired
 * in M6), and `controllers/ai/pricing.php::buildResponse()` no longer echoes
 * them either. The three columns still physically exist on
 * `ai_credit_pricing` / `ai_credit_pricing_overrides` (NOT NULL, no default)
 * until a standalone, reviewable drop script removes them per environment —
 * this repo's MySQL runs non-strict (`sql_mode` without STRICT_*), so an
 * INSERT that no longer names these columns is silently accepted.
 */
import { registerContract } from './validate'

export interface AiCredits_PricingInput {
model_name: string
cache_hit_usd_per_1m: string
cache_miss_usd_per_1m: string
output_usd_per_1m: string
valid_from: string
franquia_id?: number
}

registerContract('AiCredits_PricingInput', {
  model_name:            { type: 'string',  required: true },
  cache_hit_usd_per_1m:  { type: 'string',  required: true },
  cache_miss_usd_per_1m: { type: 'string',  required: true },
  output_usd_per_1m:     { type: 'string',  required: true },
  valid_from:            { type: 'string',  required: true },
  franquia_id:           { type: 'number',  required: false },
})
